export const fetchUpcomingPayments=fetch=>{return({organizationId})=>{return fetch("/upcoming-payments?organizationId="+organizationId)}};